var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg40BillionHoverstage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_1044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1415 54.2852H58.573C56.9952 54.2852 55.7145 53.0046 55.7145 51.4267C55.7145 50.981 55.8155 50.5501 56.0176 50.149L57.4468 47.2905C57.9341 46.3158 58.9147 45.7126 60.0023 45.7126H75.7152C76.8028 45.7126 77.7833 46.3158 78.2707 47.2905L79.6999 50.149C79.902 50.5501 80.003 50.981 80.003 51.4267C80 53.0046 78.7193 54.2852 77.1415 54.2852ZM75.7122 48.5712H59.9993L58.57 51.4297H77.1445L75.7122 48.5712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9488 79.9999H62.7657C61.2681 79.9999 60.0142 78.8292 59.9131 77.3345L58.2759 52.9539L61.1285 52.7607L62.7657 77.1414H72.9488L74.5861 52.7607L77.4387 52.9539L75.8014 77.3345C75.7004 78.8292 74.4464 79.9999 72.9488 79.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6857 68.5718H5.71407C2.56138 68.5718 0 66.0075 0 62.8578V25.7148C0 22.5621 2.56138 20.0007 5.71407 20.0007H13.8766V22.8593H5.71407C4.13921 22.8593 2.85555 24.1399 2.85555 25.7178V62.8607C2.85555 64.4356 4.13624 65.7193 5.71407 65.7193H60.6857V68.5718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2871 47.1419H61.4285V25.7148C61.4285 24.14 60.1478 22.8563 58.57 22.8563H56.1156V19.9978H58.57C61.7227 19.9978 64.2841 22.5592 64.2841 25.7119V47.1419H64.2871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7156 80.0001H18.5715C16.9967 80.0001 15.713 78.7194 15.713 77.1416C15.713 73.9889 18.2744 71.4275 21.4271 71.4275H42.8571C46.0098 71.4275 48.5712 73.9889 48.5712 77.1416C48.5712 78.7194 47.2905 80.0001 45.7156 80.0001ZM21.4301 74.286C19.8552 74.286 18.5715 75.5667 18.5715 77.1445H45.7156C45.7156 75.5697 44.4349 74.286 42.8571 74.286H21.4301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8573 66.2867L34.5729 68L38.8589 73.7147L41.1433 72.0013L36.8573 66.2867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4254 66.2834L23.1409 71.9988L25.4256 73.7115L29.7102 67.9962L27.4254 66.2834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0023 55.7144H1.42932V58.5729H60.0023V55.7144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7126 7.14331H34.2844V10.0018H45.7126V7.14331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4297 7.14331H48.5712V10.0018H51.4297V7.14331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2845 34.2844H15.713V37.1429H34.2845V34.2844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7137 27.144H29.9996V30.0026H35.7137V27.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1429 20.0007H31.4288V22.8593H37.1429V20.0007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.798 29.9996H16.3191L18.5952 20.0007H28.0533L25.798 29.9996ZM19.8997 27.1441H23.5129L24.4816 22.8593H20.8773L19.8997 27.1441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5963 34.2844H38.5723V37.1429H49.5963V34.2844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.653 23.0791L71.0262 21.9559C71.2253 21.4924 71.4036 21.1358 71.5849 20.7763C71.7334 20.4821 71.882 20.1849 72.0484 19.8105L74.6692 20.9486C74.4791 21.3824 74.3067 21.7271 74.1373 22.0659C73.9799 22.3749 73.8253 22.681 73.653 23.0791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4091 41.6L72.6189 40.979C72.7794 40.2658 72.8566 39.4784 72.8566 38.5721C72.8566 36.0523 72.2653 34.8667 71.5789 33.4969C70.839 32.0171 70.0011 30.3382 70.0011 27.144C70.0011 26.6596 70.0189 26.2109 70.0546 25.7949L72.9012 26.0356C72.8745 26.3773 72.8566 26.7458 72.8566 27.144C72.8566 29.6637 73.448 30.8493 74.1344 32.2192C74.8743 33.6989 75.7122 35.3778 75.7122 38.5721C75.7152 39.6864 75.6141 40.6789 75.4091 41.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 50.0003H5.9043L13.2794 17.6206C13.7251 15.6565 15.4426 14.2866 17.4572 14.2866H45.7126V17.1451H17.4572C16.7857 17.1451 16.2122 17.6027 16.0636 18.2565L9.48488 47.1448H20.0008V50.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1519 50.0004H18.5715V47.1418H34.8699L41.5348 17.6325C41.9746 15.6624 43.6921 14.2837 45.7126 14.2837C48.0749 14.2837 49.9974 16.2062 49.9974 18.5685C49.9974 18.8716 49.9618 19.1777 49.8905 19.5015L47.1984 31.3219C47.1597 31.5002 47.1389 31.6785 47.1389 31.8627C47.1389 33.1999 48.2384 34.2874 49.5933 34.2874C50.8413 34.2874 51.9289 33.3455 52.2379 31.9935L58.8939 2.85852H27.4086L25.4326 11.5262L22.6483 10.8903L25.1295 0H62.4775L55.0251 32.6264C54.4219 35.2858 52.1874 37.143 49.5963 37.143C46.6694 37.143 44.2863 34.7747 44.2863 31.8627C44.2863 31.4675 44.3309 31.0693 44.4201 30.689L47.1092 18.8775C47.133 18.7676 47.1449 18.6666 47.1449 18.5715C47.1449 17.7841 46.506 17.1422 45.7156 17.1422C45.0441 17.1422 44.4706 17.5998 44.325 18.2595L37.1519 50.0004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg40BillionHoverstage);
export default __webpack_public_path__ + "static/media/$40_Billion_Hoverstage.a242930b0832731f23eb013054c66dd6.svg";
export { ForwardRef as ReactComponent };